<template>
    <div style="width: 100%; height: 100%;">
        <vueCropper style="width: 100%; height: calc(100% - 50px);" ref="cropper"
                    :img="option.img"
                    :outputSize="option.outputSize"
                    :outputType="option.outputType"
                    :info="option.info"
                    :canScale="option.canScale"
                    :autoCrop="option.autoCrop"
                    :autoCropWidth="option.autoCropWidth"
                    :autoCropHeight="option.autoCropHeight"
                    :fixedBox="option.fixedBox"
                    :fixed="option.fixed"
                    :fixedNumber="option.fixedNumber"
                    :canMove="option.canMove"
                    :canMoveBox="option.canMoveBox"
                    :original="option.original"
                    :centerBox="option.centerBox"
                    :infoTrue="option.infoTrue"
                    :full="option.full"
                    :enlarge="option.enlarge"
                    :mode="option.mode"
        >
        </vueCropper>

        <div class="btn-part">
            <el-button type="primary" @click="rotateLeft">
                <font-awesome-icon icon="fa-solid fa-rotate-left" />
            </el-button>

            <el-button type="primary" @click="rotateRight">
                <font-awesome-icon icon="fa-solid fa-rotate-right" />
            </el-button>

            <el-button type="primary" @click="changeScale(3)">
                <font-awesome-icon icon="fa-solid fa-magnifying-glass-plus" />
            </el-button>

            <el-button type="primary" @click="changeScale(-3)">
                <font-awesome-icon icon="fa-solid fa-magnifying-glass-minus" />
            </el-button>

            <el-button type="primary" @click="getBase64Data">
                <span tkey="確定">{{i18n.tkey("lang_sure")}}</span>
            </el-button>
        </div>

    </div>
</template>

<script setup>
import 'vue-cropper/dist/index.css'
import { VueCropper }  from "vue-cropper";
import {reactive, ref, onBeforeMount, inject} from 'vue';
//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faRotateRight, faRotateLeft, faMagnifyingGlassMinus, faMagnifyingGlassPlus } from '@fortawesome/free-solid-svg-icons'

library.add(faRotateRight, faRotateLeft, faMagnifyingGlassMinus, faMagnifyingGlassPlus)

const props = defineProps(["ratio", 'size', "imgUrl"])
const emits = defineEmits(["save-complete"])

const i18n = inject("i18n")

const cropper = ref(null)

// const previewUrl = ref(null)

let option = reactive({
    img: '', // 裁剪图片的地址 url 地址, base64, blob
    outputSize: 1, // 裁剪生成图片的质量
    outputType: 'jpeg', // 裁剪生成图片的格式 jpeg, png, webp
    info: false, // 裁剪框的大小信息
    canScale: false, // 图片是否允许滚轮缩放
    autoCrop: true, // 是否默认生成截图框
    // autoCropWidth: 100, // 默认生成截图框宽度
    // autoCropHeight: 200, // 默认生成截图框高度
    fixedBox: true, // 固定截图框大小 不允许改变
    fixed: true, // 是否开启截图框宽高固定比例，这个如果设置为true，截图框会是固定比例缩放的，如果设置为false，则截图框的狂宽高比例就不固定了
    fixedNumber: [1, 2], // 截图框的宽高比例 [ 宽度 , 高度 ]
    canMove: true, // 上传图片是否可以移动
    canMoveBox: false, // 截图框能否拖动
    original: false, // 上传图片按照原始比例渲染
    centerBox: true, // 截图框是否被限制在图片里面
    infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
    full: true, // 是否输出原图比例的截图
    enlarge: '1', // 图片根据截图框输出比例倍数
    mode: 'contain' // 图片默认渲染方式 contain , cover, 100px, 100% auto
})

//想左转90度
function rotateLeft(){
    cropper.value.rotateLeft()
}

function rotateRight(){
    cropper.value.rotateRight()
}

function startCrop(){
    cropper.value.startCrop()
}

function stopCrop(){
    cropper.value.stopCrop()
}

function clearCrop(){
    cropper.value.clearCrop()
}

function getBlobData(){
    cropper.value.getCropBlob(data => {
        // do something
        console.log(data)
    })
}

function changeScale(value){
    cropper.value.changeScale(value)
}

function getBase64Data(){
    cropper.value.getCropData(data => {
        // do something
        // previewUrl.value = data
        emits("save-complete", data)
    })
}

onBeforeMount(() => {
    if (null != props.imgUrl){
        option.img = props.imgUrl
    }

    if (null != props.size){
        option.outputSize = props.size
    }

    if (null != props.ratio){
        option.fixedNumber = props.ratio
    }
})

</script>

<style scoped>

.btn-part {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
}


</style>